export default {"src":"/_next/static/media/musicart.699586e8.svg","height":48,"width":156};